import { baseApi } from './baseApi'

export interface LandingPageData {
  hero: {
    badge: string
    heading: string
    subheading: string
    cta_primary_text: string
    cta_secondary_text: string
    dashboard_image_id: any
  }
  features: {
    section_badge: string
    section_heading: string
    section_subheading: string
    items: {
      title: string
      description: string
      image_id: any
      color: string
    }[]
  }
  social: {
    platforms: {
      platform_id: any
      name: string
      badge: string
      title: string
      highlight: string
      description: string
      image_id: any
      features: {
        icon: string
        title: string
        description: string
        image_id: any
      }[]
    }[]
  }
  stats: {
    items: {
      val: string
      label: string
    }[]
  }
  pricing: {
    badge: string
    title: string
    description: string
    plan_ids: any[]
  }
  blog: {
    badge: string
    title: string
    description: string
    blog_ids: any[]
  }
  testimonials: {
    section_badge: string
    section_heading: string
    section_subheading: string
    testimonial_ids: any[]
  }
  faq: {
    section_badge: string
    section_heading: string
    section_subheading: string
    faq_ids: any[]
  }
  contact: {
    section_badge: string
    heading: string
    subheading: string
    email: string
    phone: string
    address: string
    live_chat_label: string
  }
  footer: {
    tagline: string
    copyright: string
    address: string
    phone: string
    email: string
    social_links: {
      name: string
      href: string
      icon: string
    }[]
  }
}

export const landingPageApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getLandingPage: builder.query<{ message: string; landing_page: LandingPageData }, void>({
      query: () => '/landing-page',
      providesTags: ['LandingPage'],
    }),
    updateLandingPage: builder.mutation<{ message: string; landing_page: LandingPageData }, Partial<LandingPageData>>({
      query: (body) => ({
        url: '/landing-page',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['LandingPage'],
    }),
  }),
})

export const { useGetLandingPageQuery, useUpdateLandingPageMutation } = landingPageApi
